<template>
  <InputPopover
    ref="popover"
    v-bind="{ modelValue, stackLabel, icon, borderless, outlined, dense, error, errorMessage, label, placeholder, useInput, clearable, autofocus, separator, multiple, disable, hideSelected, display, valueDebounce, showSelection, hideOnFirstClick, inputClass, ...$attrs }"
    :search="search"
    outlined
    :multiple="multiple"
    :loading="loading"
    :results="filteredResults"
    :placeholder="placeholder"
    friendly-name="appointment type"
    option-label="title"
    @blur="onBlur"
    @clear="onClear"
    @update:model-value="onInput"
    @clicked-result="onClickedResult"
    @removed-result="onRemovedResult"
  >
    <template v-if="canCreate" #create>
      <clickable-item
        v-close-popup
        label="Create New Appointment Type"
        @click="$refs.addDialog.open()"
      />
    </template>

    <template #option="scope">
      <TypeItem
        v-bind="scope.itemProps"
        :item="scope.opt"
      >
        <template v-if="showSelection" #default>
          <component
            :is="multiple ? 'q-checkbox' : 'q-radio'"
            :model-value="scope.selected"
            :val="true"
            class="no-pointer-events"
            dense
          />
        </template>
      </TypeItem>
    </template>

    <template #selected-chip="scope">
      <q-chip
        dense
        removable
        @remove="removeModelAtIndex(scope.index)"
      >
        <div class="overflow-hidden">
          {{ truncateString(scope.opt.name) }}
        </div>
      </q-chip>
    </template>

    <template #selected-item="scope">
      <TypeItem
        :item="scope.item"
      >
        <cancel-button
          @click="removeModelAtIndex(scope.index)"
        />
      </TypeItem>
    </template>
  </InputPopover>

  <AddTypeDialog
    ref="addDialog"
    @saved="onCreateType"
  />
</template>

<script>
import TypeItem from 'components/app/calendar/types/TypeItem.vue'
import statusMixin from 'components/app/calendar/partials/mixins/statusMixin'
import searchMixin from 'components/app/calendar/types/searchMixin'
import inputPopoverMixin from 'components/partials/search/inputPopover/inputPopoverMixin'
import InputPopover from 'components/partials/search/inputPopover/InputPopover'
import AddTypeDialog from 'components/app/settings/company/appointmentsTypes/AddTypeDialog'

export default {
  components: {
    TypeItem, InputPopover, AddTypeDialog
  },
  mixins: [statusMixin, searchMixin, inputPopoverMixin],
  props: {
    canCreate: {
      type: Boolean,
      default: false
    },
    withDeleted: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Array, Object],
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      loadedResults: false,
      filteredResults: []
    }
  },
  methods: {
    search (val, update, abort) {
      if (!this.loadedResults) {
        this.doSearch(
          this.withDeleted,
          () => {
            this.loadedResults = true
            this.filteredResults = this.results
            update()
          },
          () => {
            abort()
          }
        )
        return
      }

      this.filteredResults = !val ? this.results : this.baseSearchFilter(val)
      this.timed(() => {
        update()
      })
    },
    onCreateType (e) {
      this.onResultClick(e)
      this.loadedResults = false
    }
  }
}
</script>
